<template>
  <v-card
    outlined
  >
    <v-card-title>

      <div class="title black--text text-uppercase">
        Pacienti
      </div>

    </v-card-title>
    <v-card-subtitle>
      <div class="subtitle-6 black--text">
        Sursa pacientilor
      </div>
    </v-card-subtitle>

    <v-card-text>
      <DoughnutChart
        :chart-data="datacollection"
        :options="options"
        style="height:200px;"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'moment/locale/ro'
import DoughnutChart from '../chart/DoughnutChart.js'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
export default {
  name: 'UsersChart',
  components: { DoughnutChart, ChartJsPluginDataLabels },
  data () {
    return {
      medicuid: localStorage.getItem('useruid'),
      medicuuid: localStorage.getItem('useruuid'),
      datacollection: null,

      options: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    pacientiOnline () {
      var identificator = this.medicuid
      return this.$store.state.Pacienti.pacienti.filter(function (e) {
        if (e.sursa == 'online') {
          for (var i = 0; i < e.uidMedic.length; i++) {
            if (e.uidMedic[i].target_id == identificator) {
              return e
            }
          }
        }
      }).length
    },
    pacientiOffline () {
      var identificator = this.medicuid
      return this.$store.state.Pacienti.pacienti.filter(function (e) {
        if (e.sursa == 'offline') {
          for (var i = 0; i < e.uidMedic.length; i++) {
            if (e.uidMedic[i].target_id == identificator) {
              return e
            }
          }
        }
      }).length
    }
  },
  mounted () {
    this.loadPacienti()
    setTimeout(() => {
      this.fillData()
    }, 1000)
  },

  methods: {
    ...mapActions('Pacienti', ['loadPacienti']),
    fillData () {
      this.datacollection = {
        labels: ['Online', 'Ofline'],
        datasets: [
          {
            backgroundColor: [
              '#41B883',
              '#E46651'
            ],
            data: [this.pacientiOnline, this.pacientiOffline]
          }
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/block/UsersChart.vue